/**
 * Fabric types with default stitches per inch settings
 */

export const fabricTypes = [
  {
    id: "weavers-cloth",
    name: "Weavers Cloth",
    defaultSPI: 10,
    description: "Medium-weight foundation fabric, ideal for punch needle"
  },
  {
    id: "monks-cloth",
    name: "Monks Cloth",
    defaultSPI: 8,
    description: "Loose weave fabric, perfect for larger projects and thicker yarn"
  },
  {
    id: "linen",
    name: "Linen",
    defaultSPI: 12,
    description: "Tight weave, smooth fabric for detailed work"
  },
  {
    id: "cotton",
    name: "Cotton Fabric",
    defaultSPI: 10,
    description: "Versatile cotton foundation fabric"
  },
  {
    id: "burlap",
    name: "Burlap",
    defaultSPI: 6,
    description: "Coarse fabric for rustic, large-scale projects"
  },
  {
    id: "gripper-cloth",
    name: "Gripper Cloth",
    defaultSPI: 10,
    description: "Purpose-made punch needle fabric with tight weave"

  },
    ]
